/* @ngInject */
function NgEnter() {
    return {
        restrict: 'A',
        scope: {
            action: '&ngEnter'
        },
        link: function (scope, element) {
            element.on('keyup', function (event) {
                if (event.which === 13) {
                    event.stopPropagation();
                    event.preventDefault();
                    scope.$apply(scope.action);
                    return false;
                }
            });
        }
    };
}

export default NgEnter;